const breadCrumbSchema = (breads) => {
  const schema = {
    '@context': 'https://schema.org/',
    '@type': 'BreadcrumbList'
  };
  schema.itemListElement = breads.map((bread, index) => ({
    '@type': 'ListItem',
    position: index + 1,
    name: bread.name,
    item: bread.url
  }));

  return schema;
};

export default breadCrumbSchema;
